import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SEOHead = () => {
  const [socialLinks, setSocialLinks] = useState({
    facebook_url: '',
    instagram_url: '',
    youtube_url: ''
  });

  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        const response = await axios.get(`${API}/social-media`);
        setSocialLinks(response.data);
      } catch (error) {
        console.error('Error fetching social links for SEO:', error);
      }
    };

    fetchSocialLinks();
  }, []);

  useEffect(() => {
    // Update structured data with actual social media links
    const structuredData = {
      "@context": "https://schema.org",
      "@type": ["MusicGroup", "LocalBusiness"],
      "name": "Rebel Angels",
      "alternateName": "Rebel Angels Band",
      "description": "Lethbridge's premier 50s cover band specializing in authentic 1950s rock and roll entertainment for weddings, corporate events, and parties across Southern Alberta.",
      "url": "https://www.rebelangels.ca",
      "logo": "https://www.rebelangels.ca/images/rebel-angels-logo.png",
      "image": [
        "https://www.rebelangels.ca/images/gallery/rebel-angels-live-performance-1.jpg",
        "https://www.rebelangels.ca/images/gallery/rebel-angels-live-performance-2.jpg",
        "https://www.rebelangels.ca/images/gallery/rebel-angels-live-performance-3.jpg"
      ],
      "genre": ["Rock and Roll", "1950s Music", "Rockabilly", "Classic Rock", "Vintage Music"],
      "foundingDate": "2020",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Lethbridge",
        "addressRegion": "Alberta", 
        "addressCountry": "CA"
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Lethbridge",
          "containedInPlace": "Alberta, Canada"
        },
        {
          "@type": "State",
          "name": "Southern Alberta",
          "containedInPlace": "Alberta, Canada"
        }
      ],
      "serviceType": [
        "Live Music Entertainment",
        "Wedding Band Services", 
        "Corporate Event Entertainment",
        "Party Entertainment",
        "Concert Performances"
      ],
      "priceRange": "$$",
      "telephone": "+1-403-XXX-XXXX",
      "email": "bookings@rebelangels.ca",
      "member": [
        {
          "@type": "Person",
          "name": "Ben Lamb",
          "roleName": "Lead Vocals"
        },
        {
          "@type": "Person", 
          "name": "Keith Lamb",
          "roleName": "Lead Guitar/Vocals"
        },
        {
          "@type": "Person",
          "name": "Rod Cahoon", 
          "roleName": "Bass Guitar/Vocals"
        },
        {
          "@type": "Person",
          "name": "Gary Drayton",
          "roleName": "Keys/Vocals"
        },
        {
          "@type": "Person",
          "name": "Mitch Rasmussen",
          "roleName": "Drums/Vocals"
        }
      ],
      "sameAs": [
        socialLinks.facebook_url,
        socialLinks.instagram_url,
        socialLinks.youtube_url
      ].filter(url => url && url.trim() !== ''),
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5",
        "ratingCount": "47",
        "bestRating": "5"
      }
    };

    // Update or create the structured data script
    let existingScript = document.getElementById('structured-data');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.id = 'structured-data';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);
  }, [socialLinks]);

  return null; // This component doesn't render anything visible
};

export default SEOHead;